import { ExpenseManagementTypes } from "./expenseManagementTypes";

export const expenseManagementReducer = {
  resetExpenseManagementFetching: (state: ExpenseManagementTypes) => {
    state.fetching = false;
  },
  resetExpenseManagementSuccess: (state: ExpenseManagementTypes) => {
    state.success = null;
  },
  resetExpenseManagementError: (state: ExpenseManagementTypes) => {
    state.error = null;
  },
  resetExpenseManagementStatusCode: (state: ExpenseManagementTypes) => {
    state.statusCode = null;
  },
};
